import { schemes, zSchema } from "@zeal/common";

export const deleteEmployeeChecksRequestSchema = zSchema.object({
  check_ids: zSchema.array(schemes.mongoObjectId()),
});

export type TDeleteEmployeeChecksRequestSchema = zSchema.input<
  typeof deleteEmployeeChecksRequestSchema
>;

export const deleteEmployeeChecksResponseSchema = zSchema.object({
  deletedChecksCount: zSchema.number(),
  notFoundCheckIDs: zSchema.array(schemes.mongoObjectId()),
  notFoundCheckIDsCount: zSchema.number(),
});

export type TDeleteEmployeeChecksResponseSchema = zSchema.infer<
  typeof deleteEmployeeChecksResponseSchema
>;
